import React, { type Dispatch, type SetStateAction } from "react";

import { useAuthState } from "@synthesis/shared-auth";
import { Button, Modal, useManualModalState } from "@synthesis/shared-ui";

import { useStores } from "../../../store";

type AddModalDeleteFilesProps = object;

interface ModalDeleteFileProps extends AddModalDeleteFilesProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  openModal: () => void;
  closeModal: () => void;
}

const ModalDeleteSomeFiles = React.memo((props: ModalDeleteFileProps) => {
  return (
    <Modal.Root manual {...props}>
      <AddModalDeleteFile />
    </Modal.Root>
  );
});

const AddModalDeleteFile = React.memo(() => {
  const { generalStore } = useStores();
  const authStore = useAuthState();
  const { closeModal } = useManualModalState();

  const handleConfirm = () => {
    const userId = authStore.currentUser?.id;
    if (!userId) return;

    generalStore.deleteCheckedContents(userId);
    closeModal();
  };

  return (
    <Modal.Content className="w-[35vw] min-w-[350px]">
      <Modal.Title>Удаление нескольких файлов</Modal.Title>
      <div className="px-5">
        <h2 data-cy="modalDeleteSomeFiles-h2-projectDocks" className="mt-2">
          Вы уверены, что хотите безвозвратно удалить выбранные файлы?
        </h2>
        <div className="my-2 flex justify-between gap-4">
          <Button data-cy="modalDeleteFile-button" theme="primary" onClick={handleConfirm}>
            Удалить файлы
          </Button>
          <Button data-cy="modalDeleteFile-button" theme="secondary" onClick={() => closeModal()}>
            Отменить
          </Button>
        </div>
      </div>
    </Modal.Content>
  );
});

export default ModalDeleteSomeFiles;
